import * as React from "react";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { Spinner } from "../../../../react-core/Html/Spinner";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { subAccountTypeMap } from "../../../Dashboard/Components/Clients/PortfolioDashboard/Components/Performance/Resource/Contents";
import { ProcessNavigateCustomBtn } from "./ProcessNavigateBtn";
import { Transition } from "./Transition";

export interface ITransitionalConfirmationProps {
    onExit: () => void;
    onPrevious: () => void;
    errorMsg?: string;
    isLoading: boolean;
    buttonLabel?: string;
    from: SubAccountType;
    to: SubAccountType;
}

export class TransitionalConfirmation extends BaseComponent<ITransitionalConfirmationProps, null> {
    constructor(props: any) {
        super(props);
    }

    private renderLoading() {
        return (
            <div className="text-center">
                <h3>Submitting your applications</h3>
                <p>This could take a couple of minutes, please don't move away from this screen</p>
                <Spinner notFull={true} />
            </div>
        );
    }

    render() {
        const { isLoading, errorMsg, from, to } = this.props;
        if (isLoading) {return this.renderLoading();}

        return (
            <div className="text-center mb-54">
                <h2>{CommonHelper.isNullOrEmpty(errorMsg) ? "Success!" : "Error!"}</h2>
                {CommonHelper.isNullOrEmpty(errorMsg) && <Transition from={from} to={to} />}
                <ProcessNavigateCustomBtn
                    primary={{ title: `Open ${subAccountTypeMap[to]}`, onClick: () => this.props.onExit() }}
                    secondary={{ title: "Previous", onClick: () => this.props.onPrevious() }}
                ></ProcessNavigateCustomBtn>
            </div>
        );
    }
}
